// extracted by mini-css-extract-plugin
export default {"iconsContainer":"TwelveSignsPage_iconsContainer__7v-un"};